<template>
  <div class="signature-modal">
    <b-modal
      :id="`modal-signature-${id}`"
      title="Bitte unterschreiben Sie hier"
      size="xl"
      @show="() => shown = true"
      @hide="() => shown = false" @ok="onOk"
      no-close-on-backdrop>
      <signature-pad v-if="shown" ref="pad"/>
    </b-modal>
    <slot>
      <b-button variant="primary" size="sm" v-b-modal="`modal-signature-${id}`">
        <font-awesome-icon icon="signature"/>
        Unterschreiben
      </b-button>
    </slot>
  </div>
</template>

<script>
import SignaturePad from "@/app/components/general/SignaturePad.vue";
import {ref} from '@vue/composition-api'

export default {
  components: {SignaturePad},

  props: {
    id: {
      type: String,
      required: true,
    }
  },

  setup(props, { emit }) {
    const pad = ref(null)
    const shown = ref(false)

    const onOk = () => {
      emit('ok', pad.value.getData())
    }

    return {
      pad,
      shown,
      onOk,
    }
  }
}
</script>
